export const serverPath = 'https://admin.mmkarim.com';

